// Copyright (c) 2016 Deere & Company

export const buildSearchParams = params =>
     Object.keys(params)
        .filter(param => params[param])
        .map(param => `${param}=${params[param]}`);

export const validateDealerSearchCriteria = params => ['account', 'city', 'name1'].some(type => params[type]);



// WEBPACK FOOTER //
// ./src/product/dealer-search/service/search-params.js